var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"flex flex-wrap -m-2"},[_vm._t("before"),_vm._l((_vm.filters),function(filterPayload,filterName){return _c('li',{key:filterName,staticClass:"p-2"},[_c('ActiveFilterListItem',{attrs:{"filter":filterName,"value":_vm.getFilterValue(filterPayload),"meta":_vm.getFilterMeta(filterPayload)},on:{"remove":_vm.removeFilter}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }